import { FeedbackData, SkillsFeedback as SF } from "src/classes/models/interview";
import ScoreBadge from "./ScoreBadge";

interface ISkillsFeedback {
  feedback?: SF;
}

const SkillsFeedback = ({ feedback }: ISkillsFeedback) => {
  if (!feedback) return null;
  const { technical, intercultural } = feedback;
  const [oneInter, oneTech] = [!!intercultural?.skills?.length, !!technical?.skills?.length];
  if (!oneInter && !oneTech) return null;
  return (
    <div className="bg-white rounded-xl overflow-hidden mt-6 ">
      <div className="flex items-center justify-between px-4 py-6 border-l-odfblue border-l-4 border-b-[#ccc] border-b-[1px] ">
        <p className="font-poppins text-xl font-semibold ">{feedback.title}</p>

        <ScoreBadge feedback={feedback} />
      </div>

      <div className="px-4 py-6">
        {oneTech && (
          <p className="font-poppins text-lg text-odfblue font-semibold mb-6">Technical Skills</p>
        )}
        {technical.skills.map((skill) => (
          <SkillRow key={skill.title} skill={skill} />
        ))}

        {oneInter && (
          <p className="font-poppins text-lg text-odfblue font-semibold mb-6">
            Intercultural Skills
          </p>
        )}
        {intercultural.skills.map((skill) => (
          <SkillRow key={skill.title} skill={skill} />
        ))}
      </div>
    </div>
  );
};

const SkillRow = ({ skill }: { skill: FeedbackData }) => (
  <div className="flex justify-between mb-4 items-center gap-10 rounded-lg bg-[#F9F9F9] p-4">
    <div>
      <p className="font-poppins text-base font-semibold">• {skill.title}</p>
      <p className="font-poppins text-sm leading-[32px] mt-[10px] whitespace-pre-line">
        {skill.summary}
      </p>
    </div>
    <ScoreBadge feedback={skill} />
  </div>
);

export default SkillsFeedback;
